import { type FC, useEffect, useRef, useState } from 'react';
import { ReactComponent as QuestionIcon } from 'assets/icons/dashboard-page-icons/question.svg';
import { useInnerWidth } from 'hooks/useInnerWidth';

import * as S from './Tooltip.styled';

interface IPropsTooltip {
  tooltipIcon?: React.ReactNode;
  tooltipContent?: React.ReactNode;
}

export const Tooltip: FC<IPropsTooltip> = ({ tooltipIcon, tooltipContent }) => {
  const { innerWidth } = useInnerWidth();
  const [isContentShown, setIsContentShown] = useState(false);
  const [isLeftAligned, setIsLeftAligned] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isContentShown && contentRef.current) {
      const contentRect = contentRef.current.getBoundingClientRect();
      const contentWidth = contentRect.right - contentRect.left;
      const isLeft = contentRect.right + contentWidth < innerWidth;
      if (isLeft) {
        setIsLeftAligned(true);
      } else {
        setIsLeftAligned(false);
      }
    }
  }, [isContentShown, innerWidth]);

  useEffect(() => {
    setIsContentShown(false);
  }, [innerWidth]);

  return (
    <S.Tooltip>
      <S.TooltipIcon
        $tooltipIcon={!!tooltipIcon}
        onMouseEnter={() => setIsContentShown(true)}
        onMouseLeave={() => setIsContentShown(false)}
        onFocus={() => setIsContentShown(true)}
        onBlur={() => setIsContentShown(false)}
      >
        {tooltipIcon || <QuestionIcon />}
      </S.TooltipIcon>
      <S.TooltipContent
        $isContentShown={isContentShown}
        $isLeftAligned={isLeftAligned}
        ref={contentRef}
      >
        {tooltipContent}
      </S.TooltipContent>
    </S.Tooltip>
  );
};
